import { ENDPOINT } from 'api/endPoints/getHeatMapSummary';

import { NoPermissionMessagePortfolioPage } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.contants';
import { IHashmapItemWithCustomProps } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { EXTRA_LARGE, LARGE, MEDIUM } from 'components/Dashboards/Reporting/reportingConfig';
import { Props as TimelineAndDensityProps } from 'components/widgets/timelineAndDensity/timelineAndDensity';

export const timelineAndDensity: IHashmapItemWithCustomProps<TimelineAndDensityProps> = {
    NoPermissionMessage: NoPermissionMessagePortfolioPage,
    titleWithoutProjectAndContract: 'Portfolio',
    permission: 'PortfolioPage',
    globalFiltersConfig: [{ key: 'programTags', name: 'programTags', defaultValue: [] }],
    reportStyle: {
        widgetSizesAvailable: {
            medium: MEDIUM,
            large: LARGE,
            extraLarge: EXTRA_LARGE,
        },
        widgetInitialSize: LARGE,
    },
    id: 'portfolioTimelineAndDensity',
    componentKey: 'timelineAndDensity',
    endpoint: ENDPOINT,
};
